import React, { Component, Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBRow, MDBCol, MDBBreadcrumb, MDBBreadcrumbItem, MDBSpinner } from 'mdb-react-ui-kit'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import ResourceFactory from './../../shared/factories/resource.factory'
import ResourceTypeFactory from './../../shared/factories/resource-type.factory'
import ResourceService from './../../shared/services/Resource.service'

import './AddResourcePage.scss'

class AddResourcePage extends Component {
  state = {
    loading: false,
    resource_name: '',
    resourcetype_id: '',
    resource_link: '',
    resource_description: '',
    resource_group: '',
    resource_order: '',
    resourceTypeList: [],
    resourceTypeloading: false,
    errorMessage: '',
    formError: false,
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props
    this.setState({ urlParams: params })

    this.fetchResourceTypeData()
  }

  #onChange = event => this.setState({ [event.target.name]: event.target.value })

  validate = async () => {
    // const regLink = /^((http(s)?:\/\/)(www\.)?)+[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g;
    const regHttpLink = /^(http(s)?:\/\/).*/i
    const { resource_link, resource_name, resourcetype_id } = this.state

    /*if(!this.state.resource_link) {
            this.setState({formError: true, errorMessage: 'Resource Link Required!'});
            return;
        }

        if (this.state.resource_link && !regLink.test(this.state.resource_link)) {
            this.setState({formError: true, errorMessage: 'Invalid Link format'});
            return;
        }*/

    if (!(resource_name && resource_name.trim())) {
      this.setState({
        formError: true,
        errorMessage: 'Resource Name Required!',
      })
      return
    }
    if (!resourcetype_id) {
      this.setState({ formError: true, errorMessage: 'Resource Id Required!' })
      return
    }

    if (!(resource_link && resource_link.trim())) {
      this.setState({
        formError: true,
        errorMessage: 'Resource Link Required!',
      })
      return
    }

    if (resource_link && !regHttpLink.test(resource_link)) {
      const { resource_link } = this.state
      this.setState({ resource_link: `http://${resource_link}` })
    }

    this.setState({ formError: false, errorMessage: '' })
  }

  //create resource source
  createResource = async () => {
    await this.validate()
    const { errorMessage, formError, loading, resource_name, resource_link, resource_description, resourcetype_id } =
      this.state
    if (loading) {
      return
    }

    if (formError) {
      toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
      return
    }

    const data = {
      resource_name: resource_name,
      resourcetype_id: resourcetype_id,
      resource_link: resource_link,
      resource_description,
      active: 1,
    }

    this.setState({ loading: true })

    ResourceService.store(data)
      .then(result => {
        this.setState({ loading: false })
        this.props.history.push('/admin-resources')
        toast.success('Resource created successfully', {
          position: toast.POSITION.TOP_RIGHT,
        })
      })
      .catch(error => {
        this.setState({ loading: false })
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  fetchResourceData = async id => {
    const Resource = await ResourceFactory.findById(id)
    this.setState({ loading: false })
    if (Resource) {
      this.setState({
        resource_name: Resource.get('resource_name'),
        resourcetype_id: Resource.get('resourcetype_id'),
        resource_link: Resource.get('resource_link'),
        resource_description: Resource.get('resource_description'),
        resource_group: Resource.get('resource_group'),
        resource_order: Resource.get('resource_order'),
      })
    } else {
      toast.error('Something went wrong!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  updateResource = async () => {
    await this.validate()
    const id = this.state.urlParams.id
    const {
      loading,
      errorMessage,
      formError,
      resource_name,
      resource_link,
      resource_description,
      resourcetype_id,
      resource_group,
      resource_order,
    } = this.state
    if (loading) {
      return
    }
    if (formError) {
      toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
      return
    }
    const data = {
      resource_name: resource_name,
      resourcetype_id: resourcetype_id,
      resource_link: resource_link,
      resource_description,
      resource_group: resource_group,
      resource_order: isNaN(parseInt(resource_order)) ? 999 : resource_order,
    }

    this.setState({ loading: true })
    ResourceService.update(id, data)
      .then(result => {
        this.setState({ loading: false })
        this.props.history.push('/admin-resources')
        toast.success('Resource updated successfully', {
          position: toast.POSITION.TOP_RIGHT,
        })
      })
      .catch(error => {
        this.setState({ loading: false })
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  /**
   * Load carriers + coverages + the carrier→coverage pivot, in parallel.
   * Used to populate the cascading dropdowns under the ProductScout
   * corpus toggle.
   *
   * Pattern mirrors the GHL Sales Tracker's `coverages_by_carrier` map:
   * load everything up-front and filter client-side so the UI doesn't
   * round-trip on every dropdown change. The full pivot is small (~500
   * pairs); not worth lazy-loading.
   *
   * Silent on failure — the toggle still works without dropdowns; the
   * Laravel ingest will infer carrier + coverage from file contents.
   */
  fetchCarrierCoverageOptions = async () => {
    try {
      const [carriersRes, coveragesRes, pivotRes] = await Promise.all([
        AdminApi.getCarriers(),
        AdminApi.getCoverages(),
        CarrierCoverageService.search({ pagination: false }),
      ])

      const carrierList = (carriersRes?.data?.data || [])
        .filter(c => c.c_active)
        .sort((a, b) => (a.c_name || '').localeCompare(b.c_name || ''))

      const coverageList = (coveragesRes?.data?.data || [])
        .filter(c => c.coverage_active)
        .sort((a, b) => (a.coverage_name || '').localeCompare(b.coverage_name || ''))

      // Build { carrier_id: Set<coverage_id> } from the carriercoverage pivot.
      // The RestApi response is the `models` array for paginated calls or a
      // bare array when `pagination=false`. Handle both.
      const pivotRows = (pivotRes && (pivotRes.models || pivotRes)) || []
      const coverageByCarrier = {}
      pivotRows.forEach(row => {
        const cid = Number(row.carrier_id)
        const covid = Number(row.coverage_id)
        if (!cid || !covid) return
        if (!coverageByCarrier[cid]) coverageByCarrier[cid] = new Set()
        coverageByCarrier[cid].add(covid)
      })

      this.setState({ carrierList, coverageList, coverageByCarrier })
    } catch (e) {
      console.warn('[AddResourcePage] carrier/coverage options fetch failed', e)
    }
  }

  /**
   * Coverages offered by the currently-selected carrier, intersected
   * with the active coverages list. Mirrors GHL Sales Tracker's
   * `availableCoveragesForCarrier`.
   */
  coveragesForCurrentCarrier = () => {
    const { carrier_id, coverage_id, coverageList, coverageByCarrier } = this.state
    if (!carrier_id) return []
    const allowed = coverageByCarrier[Number(carrier_id)]
    const keepCurrent = coverage_id ? Number(coverage_id) : null
    if (!allowed) return []
    return coverageList.filter(cv => {
      const idNum = Number(cv.id)
      if (keepCurrent && idNum === keepCurrent) return true
      return allowed.has(idNum)
    })
  }

  //Fetch resource type data
  fetchResourceTypeData = async () => {
    const {
      match: { params },
    } = this.props
    this.setState({ loading: true })
    ResourceTypeFactory.findAll()
      .then(ResourceTypes => {
        this.setState({ resourceTypeList: ResourceTypes.map(RT => RT.export()) })
      })
      .then(() => {
        if (params && params.id) {
          this.fetchResourceData(params.id)
        } else {
          this.setState({ loading: false })
        }
      })
      .catch(error => {
        this.setState({ loading: false })
        toast.error('Something went wrong!', {
          position: toast.POSITION.TOP_RIGHT,
        })
      })
  }

  render() {
    toast.configure()
    const { urlParams, loading } = this.state

    return (
      <Fragment>
        <DashboardLayout>
          <main id='AddResourcePage' className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <MDBBreadcrumb>
                <MDBBreadcrumbItem>
                  <a href='/admin-resources'>List</a>
                </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>
                  {!!(urlParams && urlParams.id) ? 'Edit Resource' : 'Add Resource'}
                </MDBBreadcrumbItem>
              </MDBBreadcrumb>
              <h2 className='mb-3'>{!!(urlParams && urlParams.id) ? 'Edit Resource' : 'Add Resource'}</h2>
              <hr />
              {loading ? (
                <div className='loadingOverlay'>
                  <h4 className={'loader-text p4'}>
                    <MDBSpinner />
                  </h4>
                </div>
              ) : (
                ''
              )}
              <MDBRow>
                <MDBCol size='12'>
                  <form className='content-wrapper form-controls-bordered'>
                    <MDBRow>
                      <MDBCol size='12' md='4'>
                        <label className='grey-text' htmlFor='resource_name'>
                          Resource Name
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          name='resource_name'
                          id='resource_name'
                          value={this.state.resource_name}
                          onChange={this.#onChange}
                        />
                      </MDBCol>
                      <MDBCol size='12' md='3'>
                        <label className='grey-text' htmlFor='resource_group'>
                          Resource Group
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          name='resource_group'
                          id='resource_group'
                          value={this.state.resource_group}
                          onChange={this.#onChange}
                        />
                      </MDBCol>
                      <MDBCol size='12' md='3'>
                        <label className='grey-text' htmlFor='resourcetype_id'>
                          Resource Type
                        </label>
                        <select
                          className='form-control'
                          name='resourcetype_id'
                          id='resourcetype_id'
                          value={this.state.resourcetype_id}
                          onChange={this.#onChange}
                        >
                          <option value='' disabled>
                            Select
                          </option>
                          {this.state.resourceTypeList.map(value => (
                            <option key={value.id} value={value.id}>
                              {value.rt_name}
                            </option>
                          ))}
                        </select>
                      </MDBCol>
                      <MDBCol size='12' md='2'>
                        <label className='grey-text' htmlFor='resourcetype_id'>
                          Resource Order
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          name='resource_order'
                          id='resource_order'
                          value={this.state.resource_order}
                          onChange={this.#onChange}
                        />
                      </MDBCol>
                    </MDBRow>
                    <MDBRow>
                      <MDBCol size='12' className='mt-4'>
                        <label className='grey-text' htmlFor='resource_link'>
                          Resource Link
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          name='resource_link'
                          id='resource_link'
                          value={this.state.resource_link}
                          onChange={this.#onChange}
                        />
                      </MDBCol>
                    </MDBRow>
                    <MDBRow>
                      <MDBCol size='12' className='mt-4'>
                        <label className='grey-text' htmlFor='resource_description'>
                          Resource Description
                        </label>
                        <textarea
                          className='form-control'
                          name='resource_description'
                          id='resource_description'
                          value={this.state.resource_description}
                          onChange={this.#onChange}
                        />
                      </MDBCol>
                    </MDBRow>
                    <MDBRow>
                      <MDBCol size='12'>
                        <MDBBtn
                          color='unique'
                          type='button'
                          className='btn-block mt-5'
                          onClick={() => {
                            this.state.urlParams && this.state.urlParams.id
                              ? this.updateResource()
                              : this.createResource()
                          }}
                        >
                          {loading ? 'Saving...' : 'Save'}
                        </MDBBtn>
                      </MDBCol>
                    </MDBRow>
                  </form>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AddResourcePage
